export const reviewFilterOptions = [
  {
    label: 'Review',
    value: true
  },
  {
    label: 'More time requested',
    value: 'MORE_TIME_REQUESTED'
  }
];
